import React, { useState, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { FaLink } from 'react-icons/fa'
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Table,
    Input,
    InputGroupAddon,
    FormGroup,
    InputGroup
} from 'reactstrap'

import Header from '../../components/Header/Header'

import api from '../../services/api';

import './styles.css';

export default function Person() {
    const [email, setEmail] = useState('');
    const [peopleExist, setPeopleExist] = useState()
    const [people, setPeople] = useState([])
    const [selectedPerson, setSelectedPerson] = useState('')
    const [newName, setNewName] = useState('')
    const [activeTab, setActiveTab] = useState('1');
    const [btnDisabled, setBtnDisabled] = useState(false)
    const history = useHistory();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    let id_company = localStorage.getItem('followize_id_company');
    let id_contact = localStorage.getItem('followize_id_contact');
    let id_user = localStorage.getItem('followize_id_user');
    let token = localStorage.getItem('followize_token');

    async function storePerson(e) {
        e.preventDefault();

        if (!email) {
            alert('O email deve ser preenchido')
            return
        }

        try {
            await api.post('email/save', { email, id_user, id_company });

            localStorage.setItem('email_user', email);

            history.push('/?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);

        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <Header title="Vinculação do email" />

            <FormGroup>
                <InputGroup>
                    <Input
                        placeholder="Digite seu email da Followize"
                        value={email}
                        onChange={(item) => setEmail(item.target.value)}
                    />
                    <InputGroupAddon addonType="append">
                        <Button
                            className="btn btn-primary btn-search"
                            color="info"
                            onClick={storePerson}
                            disabled={btnDisabled}
                        >
                            <FaLink />
                        </Button>
                    </InputGroupAddon>
                </InputGroup>
            </FormGroup>
        </>
    )
}